/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateBinderPayloadDto
 */
export interface CreateBinderPayloadDto {
    /**
     * 
     * @type {string}
     * @memberof CreateBinderPayloadDto
     */
    binderName: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBinderPayloadDto
     */
    binderLongName: string;
    /**
     * 
     * @type {number}
     * @memberof CreateBinderPayloadDto
     */
    underwritingYear: number;
    /**
     * 
     * @type {string}
     * @memberof CreateBinderPayloadDto
     */
    status: string;
    /**
     * 
     * @type {Date}
     * @memberof CreateBinderPayloadDto
     */
    authorityStartDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof CreateBinderPayloadDto
     */
    authorityEndDate: Date;
    /**
     * 
     * @type {string}
     * @memberof CreateBinderPayloadDto
     */
    currency: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBinderPayloadDto
     */
    primaryMaxLimit: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBinderPayloadDto
     */
    qsEolMaxLimit: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateBinderPayloadDto
     */
    territories: Array<CreateBinderPayloadDtoTerritoriesEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateBinderPayloadDto
     */
    markets: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateBinderPayloadDto
     */
    lineOfBusinesses: Array<CreateBinderPayloadDtoLineOfBusinessesEnum>;
    /**
     * 
     * @type {string}
     * @memberof CreateBinderPayloadDto
     */
    placeBroker: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBinderPayloadDto
     */
    placementBrokerCommission: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBinderPayloadDto
     */
    pinCommission: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBinderPayloadDto
     */
    security: CreateBinderPayloadDtoSecurityEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateBinderPayloadDto
     */
    binderGroup: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBinderPayloadDto
     */
    claimsReferralAmount: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBinderPayloadDto
     */
    defaultFloatBankAccount?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateBinderPayloadDto
     */
    fileIds?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateBinderPayloadDto
     */
    excludedPrincipalOccupations?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateBinderPayloadDto
     */
    comment?: string;
}


/**
 * @export
 */
export const CreateBinderPayloadDtoTerritoriesEnum = {
    Africa: 'Africa',
    Anz: 'ANZ',
    Asia: 'Asia',
    Europe: 'Europe',
    MiddleEast: 'Middle East',
    NorthAmerica: 'North America',
    Pacific: 'Pacific',
    SouthAmerica: 'South America'
} as const;
export type CreateBinderPayloadDtoTerritoriesEnum = typeof CreateBinderPayloadDtoTerritoriesEnum[keyof typeof CreateBinderPayloadDtoTerritoriesEnum];

/**
 * @export
 */
export const CreateBinderPayloadDtoLineOfBusinessesEnum = {
    Property: 'Property',
    Power: 'Power',
    OnshoreEnergy: 'Onshore Energy',
    CrisisManagement: 'Crisis Management',
    Casualty: 'Casualty',
    ProfessionalLines: 'Professional Lines'
} as const;
export type CreateBinderPayloadDtoLineOfBusinessesEnum = typeof CreateBinderPayloadDtoLineOfBusinessesEnum[keyof typeof CreateBinderPayloadDtoLineOfBusinessesEnum];

/**
 * @export
 */
export const CreateBinderPayloadDtoSecurityEnum = {
    SpA: 'S&P A-',
    SpA2: 'S&P A',
    SpA3: 'S&P A+',
    AmBestA: 'AM Best A-',
    AmBestA2: 'AM Best A',
    AmBestA3: 'AM Best A+'
} as const;
export type CreateBinderPayloadDtoSecurityEnum = typeof CreateBinderPayloadDtoSecurityEnum[keyof typeof CreateBinderPayloadDtoSecurityEnum];


/**
 * Check if a given object implements the CreateBinderPayloadDto interface.
 */
export function instanceOfCreateBinderPayloadDto(value: object): value is CreateBinderPayloadDto {
    if (!('binderName' in value) || value['binderName'] === undefined) return false;
    if (!('binderLongName' in value) || value['binderLongName'] === undefined) return false;
    if (!('underwritingYear' in value) || value['underwritingYear'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('authorityStartDate' in value) || value['authorityStartDate'] === undefined) return false;
    if (!('authorityEndDate' in value) || value['authorityEndDate'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('primaryMaxLimit' in value) || value['primaryMaxLimit'] === undefined) return false;
    if (!('qsEolMaxLimit' in value) || value['qsEolMaxLimit'] === undefined) return false;
    if (!('territories' in value) || value['territories'] === undefined) return false;
    if (!('markets' in value) || value['markets'] === undefined) return false;
    if (!('lineOfBusinesses' in value) || value['lineOfBusinesses'] === undefined) return false;
    if (!('placeBroker' in value) || value['placeBroker'] === undefined) return false;
    if (!('placementBrokerCommission' in value) || value['placementBrokerCommission'] === undefined) return false;
    if (!('pinCommission' in value) || value['pinCommission'] === undefined) return false;
    if (!('security' in value) || value['security'] === undefined) return false;
    if (!('binderGroup' in value) || value['binderGroup'] === undefined) return false;
    if (!('claimsReferralAmount' in value) || value['claimsReferralAmount'] === undefined) return false;
    return true;
}

export function CreateBinderPayloadDtoFromJSON(json: any): CreateBinderPayloadDto {
    return CreateBinderPayloadDtoFromJSONTyped(json, false);
}

export function CreateBinderPayloadDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateBinderPayloadDto {
    if (json == null) {
        return json;
    }
    return {
        
        'binderName': json['binderName'],
        'binderLongName': json['binderLongName'],
        'underwritingYear': json['underwritingYear'],
        'status': json['status'],
        'authorityStartDate': (new Date(json['authorityStartDate'])),
        'authorityEndDate': (new Date(json['authorityEndDate'])),
        'currency': json['currency'],
        'primaryMaxLimit': json['primaryMaxLimit'],
        'qsEolMaxLimit': json['qsEolMaxLimit'],
        'territories': json['territories'],
        'markets': json['markets'],
        'lineOfBusinesses': json['lineOfBusinesses'],
        'placeBroker': json['placeBroker'],
        'placementBrokerCommission': json['placementBrokerCommission'],
        'pinCommission': json['pinCommission'],
        'security': json['security'],
        'binderGroup': json['binderGroup'],
        'claimsReferralAmount': json['claimsReferralAmount'],
        'defaultFloatBankAccount': json['defaultFloatBankAccount'] == null ? undefined : json['defaultFloatBankAccount'],
        'fileIds': json['fileIds'] == null ? undefined : json['fileIds'],
        'excludedPrincipalOccupations': json['excludedPrincipalOccupations'] == null ? undefined : json['excludedPrincipalOccupations'],
        'comment': json['comment'] == null ? undefined : json['comment'],
    };
}

export function CreateBinderPayloadDtoToJSON(json: any): CreateBinderPayloadDto {
    return CreateBinderPayloadDtoToJSONTyped(json, false);
}

export function CreateBinderPayloadDtoToJSONTyped(value?: CreateBinderPayloadDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'binderName': value['binderName'],
        'binderLongName': value['binderLongName'],
        'underwritingYear': value['underwritingYear'],
        'status': value['status'],
        'authorityStartDate': ((value['authorityStartDate']).toISOString()),
        'authorityEndDate': ((value['authorityEndDate']).toISOString()),
        'currency': value['currency'],
        'primaryMaxLimit': value['primaryMaxLimit'],
        'qsEolMaxLimit': value['qsEolMaxLimit'],
        'territories': value['territories'],
        'markets': value['markets'],
        'lineOfBusinesses': value['lineOfBusinesses'],
        'placeBroker': value['placeBroker'],
        'placementBrokerCommission': value['placementBrokerCommission'],
        'pinCommission': value['pinCommission'],
        'security': value['security'],
        'binderGroup': value['binderGroup'],
        'claimsReferralAmount': value['claimsReferralAmount'],
        'defaultFloatBankAccount': value['defaultFloatBankAccount'],
        'fileIds': value['fileIds'],
        'excludedPrincipalOccupations': value['excludedPrincipalOccupations'],
        'comment': value['comment'],
    };
}

